import { type FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { bannersByRegionIdSelector } from 'shared/selectors/banners/bannersByRegionIdSelector';
import { getFilterLocation } from 'shared/selectors/filters/getFilterLocation';
import { newbuildingsPlusBlocksPikSelector } from 'shared/selectors/specialPromosBlocks/newbuildingsPlusBlocksPikSelector';
import { extractUndefined } from 'shared/utils/extractUndefined';

import { Carousel, type CarouselBanner } from './Carousel';
import { type BadgesTypes } from './internal/components/Badges';

export const CarouselMainContainer: FC = () => {
  const bannersByRegionId = useSelector(bannersByRegionIdSelector);
  const selectedRegion = useSelector(getFilterLocation);

  const newbuildingsPlusBlocksPik = useSelector(newbuildingsPlusBlocksPikSelector);

  const banners = useMemo<CarouselBanner[]>(() => {
    const newbuildingsPlusBlocksPikMap = new Map(newbuildingsPlusBlocksPik.map(pik => [pik.newbuildingId, pik]));

    return bannersByRegionId.map((banner): CarouselBanner => {
      const badges = Array.of<BadgesTypes>();

      if (newbuildingsPlusBlocksPikMap.has(banner.jkId)) {
        badges.push('seriaPlus');
      }

      return {
        ...banner,
        badges,
        disclaimer: extractUndefined(banner.disclaimer),
        hasCommercialProperty: !!banner.hasCommercialProperty,
        label: extractUndefined(banner.label),
        logoUrl: extractUndefined(banner.logoUrl),
      };
    });
  }, [bannersByRegionId, newbuildingsPlusBlocksPik]);

  return <Carousel banners={banners} interval={4000} key={selectedRegion} testId="main-carousel" />;
};
